export enum AccountAverageWorkingHoursPerPersonRangeBoundary {
  DAY_LOWER = 6,
  DAY_MIDDLE = 9,
  DAY_UPPER = 10,
  WEEK_LOWER = 30,
  WEEK_MIDDLE = 40,
  WEEK_UPPER = 50,
}
